export default __webpack_public_path__ + "static/media/pajucara.0e42bed2.png";